import React from 'react'
import PdfPage from '../components/PdfPage'
import "./index.css"
export default function RsikDiscloure() {
  return (
    <main>
      <PdfPage
        h2={"Risk Disclousre"}
        img={"/img/risk-disclosure.jpg"}
        pdf1={"/img/Risk-Disclosure-Eng.pdf"}
        pdf1Text={"Risk Disclousre In English"}
        pdf2={"/img/Risk-Disclosure-urdu.pdf"}
        pdf2Text={"Risk Disclousre In Urdu"}
      />
    </main>)
}

